import api from './api';

export type CourseCategory = {
  id: number;
  name: string;
  fullName?: string | null;
  slug: string;
  questionCount?: number;
};

export type CategoryModule = {
  id: number;
  title: string;
  questionCount: number;
};

function normalizeCategoryId(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

export async function listModulesByCategory(categoryId: number): Promise<CategoryModule[]> {
  if (!Number.isFinite(categoryId) || categoryId <= 0) {
    return [];
  }

  const { data } = await api.get(`categories/${categoryId}/modules`);
  const rows = Array.isArray(data) ? data : [];

  return rows
    .map((item: any) => {
      const id = Number.isFinite(item?.id) ? Number(item.id) : Number.parseInt(item?.id, 10);
      const title = typeof item?.title === 'string' && item.title.trim().length > 0 ? item.title.trim() : null;
      const questionCount = Number.isFinite(item?.question_count) ? Number(item.question_count) : null;

      if (!id || !questionCount || questionCount <= 0) {
        return null;
      }

      return {
        id,
        title: title ?? `Módulo ${id}`,
        questionCount,
      } as CategoryModule;
    })
    .filter((item): item is CategoryModule => Boolean(item));
}

export async function listCourseCategories(): Promise<CourseCategory[]> {
  const { data } = await api.get('categories');
  const rows = Array.isArray(data) ? data : [];

  return rows
    .map((item: any) => {
      const id =
        normalizeCategoryId(item?.id_course_category ?? item?.id ?? item?.category_id ?? null) ?? 0;
      const name = typeof item?.name === 'string' ? item.name : '';
      const fullName = typeof item?.full_name === 'string' ? item.full_name : null;
      const slugCandidate = typeof item?.slug === 'string' ? item.slug : '';
      const questionCount = Number.isFinite(item?.question_count) ? Number(item.question_count) : null;

      if (!id || !name) {
        return null;
      }

      return {
        id,
        name,
        fullName,
        slug: slugCandidate || name.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
        questionCount: questionCount ?? undefined,
      } as CourseCategory;
    })
    .filter((item): item is CourseCategory => Boolean(item));
}
